import React from "react";

export function scorePassword(pw) {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 6) s++;
  if (pw.length >= 10) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  if (pw.length >= 14) s++;
  return Math.min(4, Math.floor((s * 4) / 6));
}

const LEVELS = [
  { label: "Too short", bar: "bg-slate-300", text: "text-slate-400" },
  { label: "Weak", bar: "bg-rose-500", text: "text-rose-600" },
  { label: "Fair", bar: "bg-amber-500", text: "text-amber-600" },
  { label: "Good", bar: "bg-lime-500", text: "text-lime-700" },
  { label: "Strong", bar: "bg-emerald-500", text: "text-emerald-700" },
];

export const PasswordStrengthMeter = ({ password, testId = "password-strength" }) => {
  if (!password) return null;
  const score = scorePassword(password);
  const lvl = LEVELS[score];
  const hint = score < 3 ? "Add length, numbers or symbols to strengthen it." : score === 3 ? "Nice. A symbol or more length makes it strong." : "Hard to guess.";
  return (
    <div className="mt-2" data-testid={testId} data-score={score}>
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors duration-300 ${i <= score ? lvl.bar : "bg-slate-200"}`}
          />
        ))}
      </div>
      <div className="flex justify-between mt-1 text-xs">
        <span className={`font-semibold ${lvl.text}`} data-testid={`${testId}-label`}>{lvl.label}</span>
        <span className="text-slate-400">{hint}</span>
      </div>
    </div>
  );
};
